module.exports = __webpack_public_path__ + "static/media/notfound.d7665a40.png";